/* global module, require */
const THREE = require('three');

function Style() {
	this.options = {};
	this.setOptions();

	this.corners = [];
	this.group = new THREE.Group();
	this.changed = false;
	this.enabled = false;
}

// override me
Style.prototype.setOptions = function() {};

Style.prototype.disable = function() {
	this.enabled = false;
	this.corners = [];
	this.removeConnections();
};

Style.prototype.enable = function() {
	this.enabled = true;
	this.planner.scene.add(this.group);
};

Style.prototype.addAt = function(position) {
	this.corners.push(new THREE.Vector3().copy(position));
	this.changed = true;
};

Style.prototype.update = function(force) {
	if (this.changed || force) {
		this.redoConnections();
		this.changed = false;
	}
};

Style.prototype.redoConnections = function() {
	this.removeConnections();
	this.enable();

	if (this.corners.length) {
		for (var i = 1; i < this.corners.length; i++) {
			this.connect(this.corners[i], this.corners[i - 1], i);
		}
	}
};

Style.prototype.removeConnections = function() {
	this.group.remove(...this.group.children);
};

Style.prototype.bounds = function() {
	return new THREE.Box3().setFromPoints(this.corners);
};

module.exports = Style;
